var React = require('react');

function CertificationIconInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"14.5714","height":"15","fill":"#1765AB","key":0}),React.createElement("path",{"d":"M7.21652 1.14307L8.64378 5.53574L13.2625 5.53574L9.52588 8.25057L10.9532 12.6432L7.21652 9.92842L3.47988 12.6432L4.90715 8.25057L1.17052 5.53574L5.78925 5.53574L7.21652 1.14307Z","fill":"white","key":1})]);
}

CertificationIconInline.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = CertificationIconInline;

CertificationIconInline.default = CertificationIconInline;
